import axios from 'axios';

export const httpClient = axios.create({
  baseURL: '/api',
});

httpClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const errorData = {
      ...error?.response?.data,
      status: error?.response?.status,
    };

    // 403 with mfaRequired is not an error - it's a normal MFA flow
    // Return the data instead of throwing
    if (errorData.status === 403 && errorData.mfaRequired) {
      return errorData;
    }

    throw errorData;
  },
);

httpClient.interceptors.request.use((config) => {
  const token = document.querySelector(
    'input[name="__RequestVerificationToken"]',
  )?.value;

  return {
    ...config,
    headers: {
      ...config.headers,
      RequestVerificationToken: token,
    },
  };
});
